/**
 * Soft Firewatch tree kit — Lambert + no ink (via withOutline / stageMat).
 */
import { ConeGeometry, CylinderGeometry, Group, Mesh } from "three";
import { stageMat, withOutline } from "../style/toon";

const trunkMat = stageMat(0x5c4030);
const leafMats = [
  stageMat(0x3d6b45),
  stageMat(0x4f7f55),
  stageMat(0x2f5a3a),
];

/** Deterministic 0–1 hash from integer seeds (tree scatter). */
export function hash01(a: number, b = 0): number {
  const x = Math.sin(a * 127.1 + b * 311.7) * 43758.5453;
  return x - Math.floor(x);
}

export function createTree(seed = 0): Group {
  const g = new Group();
  g.name = "tree";
  const scale = 0.85 + (seed % 5) * 0.08;
  const trunkH = 2.4 * scale;
  const trunk = withOutline(
    new Mesh(new CylinderGeometry(0.22 * scale, 0.32 * scale, trunkH, 6), trunkMat),
    1.05,
  );
  trunk.position.y = trunkH / 2;
  g.add(trunk);

  const leaf = leafMats[seed % leafMats.length];
  const layers = 2 + (seed % 2);
  for (let i = 0; i < layers; i++) {
    const r = (1.6 - i * 0.35) * scale;
    const h = 2.1 * scale;
    const cone = withOutline(
      new Mesh(new ConeGeometry(r, h, 7), leaf),
      1.04,
    );
    cone.position.y = trunkH + i * h * 0.45;
    g.add(cone);
  }
  return g;
}
